import React, { useContext, useEffect, useCallback } from 'react';
import { SearchIcon, XIcon } from "Res/icons";
import IconButton from "@mui/material/IconButton";
import "./styles.scss";
import SearchSuggestion from '../SearchSuggestion';
import { useWindowSize } from 'Utilities';
import RenderContext from 'Context/RenderContext';
import { useTranslation } from 'react-i18next';

const Search = ({
    className = "",
    id = "searchInput",
    isFocused,
    setIsFocused,
    handlesetsearchkeyword,
    searchResultHandler,
    inputRef,
    searchKeyword,
    showSuggestion,
    setShowSuggestion,
    setOpenSearch,
    loadingSearch,
    searchData,
    openSearch
}) => {
    const [width] = useWindowSize();
    const { loadPreRender } = useContext(RenderContext);
    const { t } = useTranslation();

    // 🧠 Handle <html> class toggle on mobile
    useEffect(() => {
        const htmlTag = document.documentElement;
        if (showSuggestion && width < 768) {
            htmlTag.classList.add("fixedHeader");
        } else {
            htmlTag.classList.remove("fixedHeader");
        }
        return () => htmlTag.classList.remove("fixedHeader");
    }, [showSuggestion, width]);

    // 🎯 Handlers
    const handleInputFocus = useCallback(() => setIsFocused(true), [setIsFocused]);

    const handleInputChange = useCallback(
        (e) => handlesetsearchkeyword(e),
        [handlesetsearchkeyword]
    );

    const handleKeyDown = useCallback(
        (e) => e.key === "Enter" && searchResultHandler(),
        [searchResultHandler]
    );

    const handleToggleSuggestion = useCallback(() => {
        setShowSuggestion(false);
        setOpenSearch(false);
        inputRef?.current?.focus();
    }, [setShowSuggestion, setOpenSearch, inputRef]);

    const isMobileSuggestionOpen = showSuggestion && width < 768;

    return (
        <div className={`search__container ${className}`}>
            <div className={`w-1/1 ${isMobileSuggestionOpen ? "zindex-20 openedmobile__suggestion" : ""}`} style={{ backgroundColor: "#fff" }}>
                <div className={`header__search px-4 lg-px-0 ${isFocused ? "focused" : ""}`}>
                    <input
                        type="text"
                        aria-label="Search"
                        className="searchbox pr-14 pl-6"
                        placeholder={t("searchplaceholder")}
                        id={id}
                        ref={inputRef}
                        value={searchKeyword}
                        onFocus={handleInputFocus}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                    <IconButton
                        className="mr-2"
                        aria-label="search toggle"
                        onClick={handleToggleSuggestion}
                    >
                        {showSuggestion ? (
                            <XIcon style={{ width: 14, height: 14 }} role="presentation"  />
                        ) : (
                            <SearchIcon role="presentation"  />
                        )}
                    </IconButton>
                </div>
            </div>

            {!loadPreRender && (
                <div className="lg-hide header__suggestion relative">
                    <SearchSuggestion
                        hideScroll={false}
                        openModel={showSuggestion}
                        setOpenModel={setShowSuggestion}
                        loading={loadingSearch}
                        searchKeyword={searchKeyword}
                        searchData={searchData}
                        openSearch={openSearch}
                        setOpenSearch={setOpenSearch}
                        setShowSuggestion={setShowSuggestion}
                    />
                </div>
            )}
        </div>
    );
};

export default Search;
